export default [
  {
    path: '/luohu-identity/create',
    name: 'luohu_identity_create',
    component: () => import('../../views/luohu-identity/Create.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/luohu-identity/remove',
    name: 'luohu_identity_remove',
    component: () => import('../../views/luohu-identity/Remove.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/luohu-identity/question',
    name: 'luohu_identity_question',
    component: () => import('../../views/luohu-identity/Question.vue'),
  },
]
